
import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "@/lib/utils";

interface SliderProps extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> {
  onValueCommit?: (value: number[]) => void;
}

const Slider = React.forwardRef<React.ElementRef<typeof SliderPrimitive.Root>, SliderProps>(({
  className,
  onValueCommit,
  ...props
}, ref) => {
  return (
    <SliderPrimitive.Root 
      ref={ref} 
      className={cn("relative flex w-full touch-none select-none items-center", className)}
      onValueCommit={onValueCommit}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden rounded-full transition-all duration-700 animate-fade-in bg-white">
        <SliderPrimitive.Range className="absolute h-full bg-primary relative overflow-hidden transition-all duration-700">
          <div className="absolute inset-0 w-full h-full bg-primary/30 -translate-x-full animate-dash"></div>
        </SliderPrimitive.Range>
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className={cn(
        "block h-4 w-4 rounded-full border-2 border-primary ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 animate-fade-in transition-all duration-700 bg-primary"
      )} />
    </SliderPrimitive.Root>
  );
});

Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };
